import { DATE_FORMAT } from '@/lib/format/date';

// Column ids, sort fields and filter keys for both Admin centre tabs.

export const ADMIN_TABS = Object.freeze({
  accessManager: 'accessManager',
  activityLog: 'activityLog',
});

export const ADMIN_DATE_TIME_FORMAT = `${DATE_FORMAT} | HH:mm`;

export const USER_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  userName: 'displayName',
  accessType: 'accessType',
  siteAccess: 'siteAccess',
  status: 'status',
  lastActive: 'lastActive',
});

// Column id → account_user column for the JSON `sort`.
// TODO: server sort to be added later — the route prepends created_at desc, so this never wins.
export const USER_SORT_FIELDS = Object.freeze({
  [USER_COLUMNS.serialNo]: 'id',
  [USER_COLUMNS.userName]: 'firstname',
  [USER_COLUMNS.accessType]: 'role',
  [USER_COLUMNS.status]: 'status',
  [USER_COLUMNS.lastActive]: 'lastactive',
});

// The server ORs these, so one box searches name and email alike.
export const USER_SEARCH_IN = Object.freeze(['firstname', 'lastname', 'email']);

export const USER_FILTERS = Object.freeze({
  accessType: 'accessType',
  lastActive: 'lastActive',
});

export const LAST_ACTIVE_PRESETS = Object.freeze({
  today: 'today',
  yesterday: 'yesterday',
});

export const USER_FIELDS = Object.freeze({
  email: 'email',
  role: 'role',
  siteIds: 'siteIds',
  siteId: 'siteId',
  storageIds: 'storageIds',
});

export const EMPTY_USER_FORM = Object.freeze({
  [USER_FIELDS.email]: '',
  [USER_FIELDS.role]: '',
  [USER_FIELDS.siteIds]: [],
  [USER_FIELDS.siteId]: '',
  [USER_FIELDS.storageIds]: [],
});

export const SITE_ACCESS_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  name: 'name',
  code: 'code',
});

export const ACTIVITY_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  dateTime: 'dateTime',
  module: 'module',
  user: 'user',
  activity: 'activity',
  action: 'action',
});

// Column id → activity_log column; module and user sort by the stored type / user id.
export const ACTIVITY_SORT_FIELDS = Object.freeze({
  [ACTIVITY_COLUMNS.serialNo]: 'id',
  [ACTIVITY_COLUMNS.dateTime]: 'created_at',
  [ACTIVITY_COLUMNS.module]: 'type',
  [ACTIVITY_COLUMNS.user]: 'logged_user_id',
});

export const ACTIVITY_FILTERS = Object.freeze({
  user: 'user',
  activityDate: 'activityDate',
  module: 'module',
});

// iscc-backend's `activityFilters.activityDate` presets.
export const ACTIVITY_DATE_PRESETS = Object.freeze({
  today: 'today',
  yesterday: 'yesterday',
  last3: 'last_3_days',
  last7: 'last_7_days',
  last30: 'last_30_days',
  last60: 'last_60_days',
});

// TODO: a searchable user picker to be added later — the User filter lists one page of users.
export const USER_OPTIONS_PAGE_SIZE = 100;
